/* eslint-disable comma-dangle */

export default {
    address: [
        'user-input',
        'map',
        'underground'
    ],
    'about-object': [
        'common/cadastral-number',
        'rooms-for-rent-count',
        'room-area',
        'urban-total-area',
        'floor',
        'rooms-for-rent-total-count',
        'kitchen-area',
        'visual-divider',
        'loggias-count',
        'balconies-count',
        'visual-divider',
        'separate-wcs-count',
        'combined-wcs-count',
        'visual-divider',
        'repair-type',
        'visual-divider',
        'pets-allowed',
        'children-allowed',
        'visual-divider',
        'additional-simple-form',
    ],
    'about-building': [
        'name-and-year',
        'material-type-and-series',
        'ceiling-height',
        'passenger-lifts',
        'cargo-lifts',
        'has-ramp',
        'in-house',
        'parking'
    ],
    'price-and-deal-terms': [
        'price-rent',
        'utilities-terms',
        'visual-divider',
        'bargain',
        'prepay-type',
        'self-employed',
        'deposit',
        'tenants-type',
        'fee'
    ]
};
